import jwtDecode from 'jwt-decode';
import { DecodedJwt } from '@sls-react/typings/services/iam/auth';

export default function decodeJwt(accessToken?: string) {
  if (accessToken) {
    try {
      return jwtDecode<DecodedJwt>(accessToken);
    } catch (e) {
      return null;
    }
  }
  return null;
}
